import React, { useState, useEffect } from 'react';
import path from 'path';
import _ from 'lodash';
import '../scss/components/newVersionAvailable.scss';
import { useServiceWorker } from '../hooks/useServiceWorker';

const NewVersionAvailable = props => {
  const [mainJsFilename, setMainJsFilename] = useState(props.mainJsFilename);
  const [isUpdate, setIsUpdate] = useState(false);
  const { isUpdateAvailable, updateServiceWorker, updateAssets } = useServiceWorker();

  useEffect(() => {
    if (_.trim(props.mainJsFilename) !== '') {
      setMainJsFilename(props.mainJsFilename);
    }
  }, [props.mainJsFilename]);

  useEffect(() => {
    let getNowVersionTimer = null;

    if (process.env.REACT_APP_NODE_ENV !== 'development') {
      getNowVersionTimer = setInterval(() => {
        fetch('/asset-manifest.json', { cache: 'no-cache' })
          .then(response => {
            if (!response.ok) {
              throw new Error('沒有資源檔案列表');
            }

            return response.json();
          })
          .then(json => {
            const mainFile = json.files['main.js'];
            const nowMainJsFilename = path.basename(mainFile);

            if (mainJsFilename === '') {
              setMainJsFilename(nowMainJsFilename);
            } else if (mainJsFilename !== nowMainJsFilename) {
              updateServiceWorker();
              setMainJsFilename(nowMainJsFilename);
            }
          })
          .catch(error => {
            // just for stop error
          });
      }, 60000);
    }

    return () => {
      if (getNowVersionTimer !== null) {
        clearInterval(getNowVersionTimer);
      }
    };
  }, [updateServiceWorker, setMainJsFilename]);

  const updateNewVersion = () => {
    setIsUpdate(true);
    updateAssets();
  };

  return (
    <div
      className={
        isUpdateAvailable
          ? 'new-version-available-box new-version-available-box-show'
          : 'new-version-available-box'
      }
    >
      {!isUpdateAvailable ? null : (
        <div className="nva-card row">
          <div className="col-9 col-pad-9 col-phone-9 nva-fix-col">
            <i class="fa fa-desktop"></i> 新版本程式已發佈。
          </div>
          <div className="col-3 col-pad-3 col-phone-3 nva-fix-col nva-button-box">
            <button className="nva-button" onClick={updateNewVersion} disabled={isUpdate}>
              <i className="fa fa-retweet"></i> 更新
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default NewVersionAvailable;
